import styled from 'styled-components';

export const StyledContent = styled.div`
  .identity__form {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .identity__field {
    margin-bottom: 0;
    + .identity__field {
      margin-top: 24px;
    }
    &.with-error {
      margin-bottom: 0;

      + .identity__field {
        margin-top: 32px;
      }
    }
  }
  .identity__small-text {
    margin-top: 30px;
    align-self: center;
  }

  .identity__sign-up-link {
    font-size: 16px;
  }

  .identity__activate-link {
    font-size: 16px;
  }

  .identity__link {
    margin-bottom: 0px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #00012b;
    text-decoration: underline;

    &.open {
      margin-top: 0px;
    }
    &.first {
      margin-top: 24px;
    }
    &.last {
      margin-bottom: 0px;
    }
  }

  .form-buttom {
    margin: 24px 0 0;
  }

  .identity__legal-text {
    color: #747474;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin-top: 24px;
  }
`;
